import { m as a } from "./map_object.js";
var e = a, m = function(r) {
  return e(r, function(t, n) {
    return t;
  });
};
export {
  m as v
};
